/**
 * The explicit add (2026-09-06; owner: "Just cuz I click on a component
 * doesn't mean I wanna add all of them to the chat. I might wanna click
 * through components and read them. It should be an explicit add"): a click
 * on a part opens it to read; THIS puts it in the question as an @ token,
 * and takes it back out.
 */

export function AtSign() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className="shrink-0"
    >
      <circle cx="12" cy="12" r="4" />
      <path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8" />
    </svg>
  );
}

export function AddToQuestionButton({
  inQuestion = false,
  onClick,
  testId,
}: {
  /** already in the composer: the press takes it out */
  inQuestion?: boolean;
  onClick: () => void;
  testId: string;
}) {
  return (
    <button
      type="button"
      data-testid={testId}
      aria-pressed={inQuestion}
      onClick={onClick}
      title={
        inQuestion
          ? 'Takes its @ token out of your question'
          : 'Puts it in your question as an @ token; the words are yours'
      }
      className={`inline-flex cursor-pointer items-center gap-1.5 rounded-chip border px-2 py-1 text-[length:var(--text-micro-size)] leading-[var(--text-micro-line)] transition-colors duration-(--motion-hover) ${
        inQuestion
          ? 'border-(--accent) bg-accent-subtle text-accent'
          : 'border-default bg-transparent text-secondary hover:border-(--accent) hover:text-primary'
      }`}
    >
      <AtSign />
      {inQuestion ? 'In your question' : 'Add to question'}
    </button>
  );
}
